import { render } from "./ServicePublicPage.vue?vue&type=template&id=a2ff223e"
import script from "./ServicePublicPage.vue?vue&type=script&lang=js"
export * from "./ServicePublicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__